import { Component } from "@angular/core";
import { environment } from "environment";
import { IdleTimeoutEvent, IdleTimerService } from "./common/services/idle-timer.service";
import { RouteTrackingService } from "./common/services/route-tracking.service";
import { StorageService } from "./common/services/storage.service";
import { AuthService } from "./services/auth.service";
import { IdleTimerConstants } from "./common/constants/idle-timer.constants";
import { GrowthBookService } from "./services/growthbook.service";
import { filter, map, Subject, takeUntil } from "rxjs";
import { FeatureFacade } from "./common/feature-flags/feature-facade.service";
import { LayoutService } from "./services/layout.service";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  private destroy$ = new Subject<void>();

  isPhysican: boolean;
  footerEnabled$ = this.gbService.userReady$.pipe(
    filter(v => v === true),
    map(() => this.featureFacade.isFooterEnabled())
  );

  constructor(
    public storageService: StorageService,
    private routeTrackingService: RouteTrackingService,
    private idleTimerService: IdleTimerService,
    private authService: AuthService,
    private router: Router,
    private gbService: GrowthBookService,
    private featureFacade: FeatureFacade,
    private dialog: MatDialog,
    public layoutService : LayoutService
  ) {
    this.isPhysican = false;
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }

  async ngOnInit() {
    await this.gbService.init();
    this.routeTrackingService.init();

    this.layoutService.inMobile$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isMobile) => {
        if (isMobile) {
          this.dialog.closeAll();
        }
      });

    this.layoutService.mobileToDesktop$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const hasSession = this.storageService.getUser() !== null;
        const wasLockedDueToIdle = this.storageService.getLastActiveUserId() !== null;

        if (!hasSession || !wasLockedDueToIdle) {
          this.router.navigate(['/home'], { replaceUrl: true });
        }
      });

    this.storageService.isUserPhysician.subscribe((val) => {
      this.isPhysican = val;
    });
    this.setIdleTimer();
  }

  setIdleTimer() {
      if (!!environment.idleTimeBeforeLocking && !!environment.idleTimeBeforeTerminating) {
        const timers: IdleTimeoutEvent[] = [
          { time: environment.idleTimeBeforeLocking, message: IdleTimerConstants.lockUser },
          { time: environment.idleTimeBeforeTerminating, message: IdleTimerConstants.terminateUser },
        ];
        this.idleTimerService.setTimers(timers).subscribe((timerData) => {
            this.idleTimerService.stop();
            if (timerData.message === IdleTimerConstants.lockUser) {
              this.timeoutMotomoLog(timerData);
              this.authService.lockUserSession();
            } else if (timerData.message === IdleTimerConstants.terminateUser) {
              this.timeoutMotomoLog(timerData);
              this.authService.logout();
            }
          });
      }
    }

    ngOnDestroy() {
      this.idleTimerService.stop();
      this.destroy$.next(); 
      this.destroy$.complete();
    }

    timeoutMotomoLog(timerData: any){
      const userJson = sessionStorage.getItem('user');
      let userId = 'anonymous';
      let username = 'anonymous';
      if (userJson) {
        try {
          const user = JSON.parse(userJson);
          userId = user.id || 'anonymous';
          username = user.fullname || 'anonymous';
        } catch (err) {
          console.warn('Failed to parse user from sessionStorage', err);
        }
      }

      if (window._paq) {
        window._paq.push([
          'trackEvent',
          'idle Timeout',
          'Logout',
          `${timerData.message} | ${userId}/${username}`
        ]);
      }
    }
}
